import React from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { formatPrice } from '@catalogo/core-helpers/price';

const Green = styled.span`
  color: ${({ theme }) => theme.success.medium};
`;

export const Cashback = ({ payment }) => {
  const cashbackValue = getIn(payment, ['cashback', 'value']);
  const cashbackRate = getIn(payment, ['cashback', 'rate']);

  if (!cashbackValue) {
    return null;
  }

  if (cashbackRate > 10 || cashbackValue < 1) {
    return (
      <>
        e receba R$ {formatPrice(cashbackValue)} <Green>({cashbackRate}% de volta)</Green>
      </>
    );
  }

  return (
    <>
      e receba <Green>R$ {formatPrice(cashbackValue)} de volta</Green>
    </>
  );
};
